import { CSVTableRowProps } from 'types';
import { Input, Select } from './styles';

const ColumnNameRow = ({ rowIndex, columnLabels, isEditMode, values, useFormReturn }: CSVTableRowProps) => {
  const { register, watch } = useFormReturn;
  const nameTypeIsIndex = watch('columnNameType') === 'index';

  if (isEditMode) {
    return (
      <tr>
        <th>컬럼명</th>
        <td>
          <Select {...register('columnNameType')}>
            <option value="name">컬럼명</option>
            <option value="index">index</option>
          </Select>
        </td>
        {columnLabels.map((label, i) => (
          <td key={`col/${label}/row/${rowIndex}/edit`}>
            {values?.[i] !== undefined &&
              (nameTypeIsIndex ? (
                <span>{i}</span>
              ) : (
                <Input {...register(`columnNames.${i}`)} placeholder={`컬럼 ${i}`} />
              ))}
          </td>
        ))}
      </tr>
    );
  }

  return (
    <tr>
      <th>{rowIndex}</th>
      {columnLabels.map((label, i) => (
        <td key={`col/${label}/row/${rowIndex}`}>
          {values?.[i] !== undefined && <span>{values[i] === '' ? `컬럼${i}` : values[i]}</span>}
        </td>
      ))}
    </tr>
  );
};

export default ColumnNameRow;
